import { useState, useEffect } from "react";
import ButtonComponent from "../../../components/common/button/Button";
import Modal from "../../../components/common/modal/Modal";
import { TextField } from "@mui/material";
import "./index.css";

const AddDomainModal = ({
  openAddDomainModal,
  handleCloseAddDomainModal,
  handleSubmitAddDomainModal,
}) => {
  const [domainName, setDomainName] = useState("");

  useEffect(() => {
    if (openAddDomainModal) {
      setDomainName("");
    }
  }, [openAddDomainModal]);

  const handleClearAll = () => {
    setDomainName("");
  };

  const onClickCancel = () => {
    handleClearAll();
    handleCloseAddDomainModal();
  };

  const onClickSubmit = () => {
    handleSubmitAddDomainModal({
      domainName: domainName.trim(),
    });
  };

  return (
    <Modal
      className="InviteUserModal_cls"
      open={openAddDomainModal}
      handleClose={onClickCancel}
      title="Add Domain"
      fullWidth
      maxWidth="sm"
      action={
        <div
          className="btn-wrapper_inviteUser"
          style={{ display: "flex", gap: 10 }}
        >
          <ButtonComponent
            label="Back"
            type="primary"
            maxWidth="80px"
            onClick={onClickCancel}
          />

          <ButtonComponent
            label="Clear All"
            type="primary"
            maxWidth="120px"
            onClick={handleClearAll}
          />

          <ButtonComponent
            label="Save"
            type="secondary"
            maxWidth="100px"
            onClick={onClickSubmit}
            disabled={!domainName.trim()}
          />
        </div>
      }
      content={
        <div style={{ marginTop: 10 }}>
          <div
            style={{
              marginBottom: 8,
              fontWeight: "bold",
            }}
          >
            Domain Name
          </div>

          <TextField
            fullWidth
            placeholder="Enter Domain Name"
            value={domainName}
            onChange={(e) => setDomainName(e.target.value)}
            sx={{
              "& .MuiInputBase-root": {
                height: 40,
              },
            }}
          />
        </div>
      }
    />
  );
};

export default AddDomainModal;